import React from 'react';
import PropTypes from 'prop-types';
import {Message} from 'epic-diesel-common';
import {getMessage} from '../../common/Message';
import CheckBox from 'epic-diesel-form/src/components/form/CheckBox';
import styles from './UserInfoSection.pcss';
import signupStyles from '../../../pages/signup/SignUp.pcss';

export default class UserInfoSection extends React.Component {
    static propTypes = {
        messages: PropTypes.object,
        form: PropTypes.object,
        sectionData: PropTypes.object,
        updateTwoFactorAuthentication: PropTypes.func
    };
    static defaultProps = {
        sectionData: {}
    };

    render() {
        const {sectionData, form, messages} = this.props;
        
        const twoFaText = getMessage(messages, 'epic.affiliate.signup.mfa.text');

        return (
            <div className={signupStyles.header}>
                <h2>
                    <Message code="epic.affiliate.signup.mfa.header" />
                    {' *'}
                </h2>
                <p className={styles.anchor}>
                    <span dangerouslySetInnerHTML={{__html: twoFaText}} />
                </p>
                <div className={styles.userAccountInfoItem}>
                    <div>
                        <Message code="epic.affiliate.signup.mfa.email" />
                        <span>{sectionData.email}</span>
                    </div>
                    <div>
                        <Message code="epic.affiliate.signup.mfa.display_name" />
                        <span>{sectionData.displayName}</span>
                    </div>
                </div>
                <div className={styles.authentication}>
                    <CheckBox
                        name="acceptMfa"
                        validations="checked"
                        validationError={getMessage(messages, 'ui.form.agreement.required')}
                        value={form && form.acceptMfa}
                        onChange={this.props.updateTwoFactorAuthentication}>
                        <Message code="epic.affiliate.signup.mfa.acknowledge" />
                    </CheckBox>
                </div>
            </div>
        );
    }
}
